import React from 'react'
import GetManagementStatus from './MyMapUtils/GetManagementStatus';

export default function FilterPanelReport(props) {
    function onClickFilterButton(filterKind,filterKind_str,filterKind_end,popupKind,masterKind,isFacilityType,targetTypes,DateTime_str,DateTime_end,label){
        props.updateShowFiltersInfo({ type: "filterKind", value: filterKind });
        props.updateShowFiltersInfo({ type: "filterKind_str", value: filterKind_str });
        props.updateShowFiltersInfo({ type: "filterKind_end", value: filterKind_end });
        props.updateShowFiltersInfo({ type: "popupKind", value: popupKind });
        props.updateShowFiltersInfo({ type: "masterKind", value: masterKind });
        props.updateShowFiltersInfo({ type: "isFacilityType", value: isFacilityType });
        props.updateShowFiltersInfo({ type: "targetTypes", value: targetTypes });
        props.updateShowFiltersInfo({ type: "DateTime_str", value: DateTime_str });
        props.updateShowFiltersInfo({ type: "DateTime_end", value: DateTime_end });
        props.updateShowFiltersInfo({ type: "label", value: label });
        props.onClick();
    };
    const handleClose = () => {
        props.onBack();
    };
    
    return (
        <div className="filter-panel" style={props.getStyle()}>
            <div role="main" className="filter-flex">
                <div className="filter-header">
                    <div className="filter-header-buttons-left">
                        <button aria-label="戻る"
                            className="filter-header-back-button"
                            onClick={handleClose}
                        >
                            <i className="bi bi-arrow-left"></i>
                        </button>
                    </div>

                    <div className="filter-header-title">
                        <span>{props.showFilterInfo.label}</span>
                    </div>

                </div>
                <div className="filter-content">
                    <div>
                        <button
                            className='filter-button'
                            onClick={()=>onClickFilterButton(
                                "reportDate","reportDate_str","reportDate_end","date",null,false,null,
                                props.filters.reportDate_str,props.filters.reportDate_end,"通報日"
                            )}
                            >
                            <div className='filter-button-title'>
                                    <span>通報日</span>
                                    {
                                        (props.filters.reportDate_str || props.filters.reportDate_end?
                                            <span className='filter-items'>{props.filters.reportDate_str} ～ {props.filters.reportDate_end}</span>
                                            :
                                            null
                                        )
                                    }
                            </div>
                        </button>
                        <div className="sr-line"></div>
                    </div>
                    <div>
                        <button
                            className='filter-button'
                            onClick={()=>onClickFilterButton(
                                "reportStatus",null,null,"list","reportStatus",false,props.filters.reportStatus,
                                null,null,"ステータス"
                            )}
                            >
                            <div className='filter-button-title'>
                                    <span>ステータス</span>
                                    {props.filters.reportStatus && props.filters.reportStatus.length > 0 ?
                                        <span className='filter-items'>{props.filters.reportStatus.map(x=>GetManagementStatus("reportStatus",x,"name")).join("、")}</span>
                                        :
                                        null
                                    }
                                    </div>
                        </button>
                        <div className="sr-line"></div>
                    </div>
                </div>
                    
            </div>
        </div>
    );

}